export enum NicotineProtocolStatus {
  NOT_SMOKER = 'NOT_SMOKER',
  PAST_SMOKER = 'PAST_SMOKER',
  SMOKER_NO_SUPPORT_REQUIRED = 'SMOKER_NO_SUPPORT_REQUIRED',
  NICOTINE_PATCH_REQUIRED = 'NICOTINE_PATCH_REQUIRED',
  NICOTINE_PATCH_DONE = 'NICOTINE_PATCH_DONE',
  NICOTINE_PATCH_AND_SPECIALIST_REFERRAL_REQUIRED = 'NICOTINE_PATCH_AND_SPECIALIST_REFERRAL_REQUIRED',
  NICOTINE_PATCH_AND_SPECIALIST_REFERRAL_MANUALLY_DONE = 'NICOTINE_PATCH_AND_SPECIALIST_REFERRAL_MANUALLY_DONE',
  NICOTINE_PATCH_AND_SPECIALIST_REFERRAL_DONE = 'NICOTINE_PATCH_AND_SPECIALIST_REFERRAL_DONE'
}

export enum AnemiaProtocolStatus {
  AUTO_NO_HB_DETECTED = 'AUTO_NO_HB_DETECTED',
  AUTO_POTENTIALLY_ANEMIC = 'AUTO_POTENTIALLY_ANEMIC',
  AUTO_POTENTIALLY_NOT_ANEMIC = 'AUTO_POTENTIALLY_NOT_ANEMIC',
  AUTO_ANEMIA_NOT_DETECTED = 'AUTO_ANEMIA_NOT_DETECTED',
  AUTO_ANEMIA_DETECTED = 'AUTO_ANEMIA_DETECTED',
  AUTO_IRON_INJECTION_PRESCRIPTION_RECOMMENDED = 'AUTO_IRON_INJECTION_PRESCRIPTION_RECOMMENDED',
  AUTO_EPO_AND_IRON_INJECTION_PRESCRIPTION_RECOMMENDED = 'AUTO_EPO_AND_IRON_INJECTION_PRESCRIPTION_RECOMMENDED',
  AUTO_EXPERT_REFERRAL_RECOMMENDED = 'AUTO_EXPERT_REFERRAL_RECOMMENDED',
  ANEMIA_NOT_CONFIRMED = 'ANEMIA_NOT_CONFIRMED',
  ANEMIA_CONFIRMED_NO_ACTION_REQUIRED = 'ANEMIA_CONFIRMED_NO_ACTION_REQUIRED',
  ANEMIA_CONFIRMED_OTHER = 'ANEMIA_CONFIRMED_OTHER',
  EXTRA_LAB_TESTS_REQUESTED = 'EXTRA_LAB_TESTS_REQUESTED',
  EXPERT_REFERRAL_SENT = 'EXPERT_REFERRAL_SENT',
  EPO_PRESCRIPTION_SENT = 'EPO_PRESCRIPTION_SENT',
  IRON_INJECTION_PRESCRIPTION_SENT = 'IRON_INJECTION_PRESCRIPTION_SENT',
  IRON_INJECTION_AND_EPO_PRESCRIPTIONS_SENT = 'IRON_INJECTION_AND_EPO_PRESCRIPTIONS_SENT',
  IRON_INJECTION_SCHEDULED = 'IRON_INJECTION_SCHEDULED',
  IRON_INJECTIONS_DONE = 'IRON_INJECTIONS_DONE'
}

export const isCopilotStatus = (status?: AnemiaProtocolStatus | string) =>
  !!status &&
  [
    AnemiaProtocolStatus.AUTO_NO_HB_DETECTED,
    AnemiaProtocolStatus.AUTO_POTENTIALLY_ANEMIC,
    AnemiaProtocolStatus.AUTO_POTENTIALLY_NOT_ANEMIC,
    AnemiaProtocolStatus.AUTO_ANEMIA_NOT_DETECTED,
    AnemiaProtocolStatus.AUTO_ANEMIA_DETECTED,
    AnemiaProtocolStatus.AUTO_IRON_INJECTION_PRESCRIPTION_RECOMMENDED,
    AnemiaProtocolStatus.AUTO_EPO_AND_IRON_INJECTION_PRESCRIPTION_RECOMMENDED,
    AnemiaProtocolStatus.AUTO_EXPERT_REFERRAL_RECOMMENDED
  ].includes(status as any);

export enum SleepApneaProtocolStatus {
  OSA_NOT_SCREENED = 'OSA_NOT_SCREENED',
  OSA_LOW_RISK = 'OSA_LOW_RISK',
  OSA_MEDIUM_RISK = 'OSA_MEDIUM_RISK',
  OSA_HIGH_RISK = 'OSA_HIGH_RISK',
  OSA_DIAGNOSED_WITHOUT_CPAP = 'OSA_DIAGNOSED_WITHOUT_CPAP',
  OSA_DIAGNOSED_WITH_CPAP = 'OSA_DIAGNOSED_WITH_CPAP',
  OSA_MEDIUM_RISK_REFERRAL_DONE = 'OSA_MEDIUM_RISK_REFERRAL_DONE',
  OSA_HIGH_RISK_REFERRAL_DONE = 'OSA_HIGH_RISK_REFERRAL_DONE',
  OSA_RISK_IDENTIFIED_NO_ACTION = 'OSA_RISK_IDENTIFIED_NO_ACTION'
}

export enum NutritionSupportProtocolStatus {
  UNDER_NUTRITION_SUSPECTED = 'UNDER_NUTRITION_SUSPECTED',
  UNDER_NUTRITION_LOW_PROBABILITY = 'UNDER_NUTRITION_LOW_PROBABILITY',
  UNDER_NUTRITION_CONFIRMED = 'UNDER_NUTRITION_CONFIRMED',
  UNDER_NUTRITION_NOT_CONFIRMED = 'UNDER_NUTRITION_NOT_CONFIRMED',
  UNDER_NUTRITION_ALBUMIN_TEST_SENT = 'UNDER_NUTRITION_ALBUMIN_TEST_SENT',
  UNDER_NUTRITION_PROTEIN_SENT = 'UNDER_NUTRITION_PROTEIN_SENT',
  UNDER_NUTRITION_REFERRAL_DONE = 'UNDER_NUTRITION_REFERRAL_DONE',
  UNDER_NUTRITION_PROTEIN_SENT_AND_REFERRAL_DONE = 'UNDER_NUTRITION_PROTEIN_SENT_AND_REFERRAL_DONE'
}

export enum TelehealthProtocolStatus {
  PENDING_ELIGIBILITY = 'PENDING_ELIGIBILITY',
  AUTO_ELIGIBLE_FOR_TELEVISIT = 'AUTO_ELIGIBLE_FOR_TELEVISIT',
  AUTO_NOT_ELIGIBLE_FOR_TELEVISIT = 'AUTO_NOT_ELIGIBLE_FOR_TELEVISIT',
  AUTO_UNKNOWN_ELIGIBILITY = 'AUTO_UNKNOWN_ELIGIBILITY',
  NOT_ELIGIBLE_FOR_TELEVISIT = 'NOT_ELIGIBLE_FOR_TELEVISIT',
  ELIGIBLE_FOR_TELEVISIT = 'ELIGIBLE_FOR_TELEVISIT',
  APPOINTMENT_BOOKED = 'APPOINTMENT_BOOKED',
  TELEVISIT_FAILED_APPOINTMENT_NOT_BOOKED = 'TELEVISIT_FAILED_APPOINTMENT_NOT_BOOKED',
  TELEVISIT_FAILED_NO_SHOW = 'TELEVISIT_FAILED_NO_SHOW',
  TELEVISIT_FAILED_NEED_PHYSICAL_VISIT = 'TELEVISIT_FAILED_NEED_PHYSICAL_VISIT',
  TELEVISIT_FAILED_OTHER = 'TELEVISIT_FAILED_OTHER',
  TELEVISIT_DONE_INFORMED_CONSENT_SENT = 'TELEVISIT_DONE_INFORMED_CONSENT_SENT',
  TELEVISIT_DONE_INFORMED_CONSENT_SIGNED = 'TELEVISIT_DONE_INFORMED_CONSENT_SIGNED',
  COMPLETE_REPORT_SENT = 'COMPLETE_REPORT_SENT',
  BILLED = 'BILLED'
}

export enum PreopLabTestProtocolStatus {
  PREOPERATIVE_LAB_TEST_NOT_APPLICABLE = 'PREOPERATIVE_LAB_TEST_NOT_APPLICABLE',
  PREOPERATIVE_LAB_TEST_PROBABLY_NOT_RECOMMENDED = 'PREOPERATIVE_LAB_TEST_PROBABLY_NOT_RECOMMENDED',
  PREOPERATIVE_LAB_TEST_MISSING = 'PREOPERATIVE_LAB_TEST_MISSING',
  PREOPERATIVE_LAB_TEST_NOT_RECOMMENDED = 'PREOPERATIVE_LAB_TEST_NOT_RECOMMENDED',
  PREOPERATIVE_LAB_TEST_UPLOADED_TO_CHECK = 'PREOPERATIVE_LAB_TEST_UPLOADED_TO_CHECK',
  PREOPERATIVE_LAB_TEST_PRESCRIPTION_SENT = 'PREOPERATIVE_LAB_TEST_PRESCRIPTION_SENT',
  PREOPERATIVE_LAB_TEST_ALL_DONE_AND_REVIEWED = 'PREOPERATIVE_LAB_TEST_ALL_DONE_AND_REVIEWED',
  PREOPERATIVE_LAB_TEST_COMPLETED = 'PREOPERATIVE_LAB_TEST_COMPLETED'
}

export enum CardiacStressTestProtocolStatus {
  CARDIAC_STRESS_TEST_AUTO_UNKNOWN_ELIGIBILITY = 'CARDIAC_STRESS_TEST_AUTO_UNKNOWN_ELIGIBILITY',
  CARDIAC_STRESS_TEST_AUTO_RECOMMENDED = 'CARDIAC_STRESS_TEST_AUTO_RECOMMENDED',
  CARDIAC_STRESS_TEST_AUTO_NOT_RECOMMENDED = 'CARDIAC_STRESS_TEST_AUTO_NOT_RECOMMENDED',
  CARDIAC_STRESS_TEST_AUTO_ALREADY_UPLOADED = 'CARDIAC_STRESS_TEST_AUTO_ALREADY_UPLOADED',
  CARDIAC_STRESS_TEST_WAITING_FOR_APPOINTMENT = 'CARDIAC_STRESS_TEST_WAITING_FOR_APPOINTMENT',
  CARDIAC_STRESS_TEST_SCHEDULED = 'CARDIAC_STRESS_TEST_SCHEDULED',
  CARDIAC_STRESS_TEST_WAITING_FOR_RESULTS = 'CARDIAC_STRESS_TEST_WAITING_FOR_RESULTS',
  CARDIAC_STRESS_TEST_RESULTS_RECEIVED = 'CARDIAC_STRESS_TEST_RESULTS_RECEIVED',
  CARDIAC_STRESS_TEST_NOT_REQUIRED = 'CARDIAC_STRESS_TEST_NOT_REQUIRED',
  CARDIAC_STRESS_TEST_DONE_CLEARED = 'CARDIAC_STRESS_TEST_DONE_CLEARED',
  CARDIAC_STRESS_TEST_NOT_CLEARED = 'CARDIAC_STRESS_TEST_NOT_CLEARED'
}

export enum SurgeryPlanningProtocolStatus {
  NOT_EVALUATED = 'NOT_EVALUATED',
  PENDING = 'PENDING',
  PRE_REVIEWED = 'PRE_REVIEWED',
  CLEARED_WITH_CONDITIONS = 'CLEARED_WITH_CONDITIONS',
  CLEARED = 'CLEARED',
  NOT_CLEARED_TO_RESCHEDULE = 'NOT_CLEARED_TO_RESCHEDULE',
  NOT_CLEARED = 'NOT_CLEARED',
  CANCELLED = 'CANCELLED'
}

export enum PreopChronicPainProtocolStatus {
  NOT_RECOMMENDED = 'PREOP_CHRONIC_PAIN_NOT_RECOMMENDED',
  TO_EVALUATE = 'PREOP_CHRONIC_PAIN_TO_EVALUATE',
  CHRONIC_PAIN_RISK_CONFIRMED = 'PREOP_CHRONIC_PAIN_RISK_CONFIRMED',
  CHRONIC_PAIN_RISK_NOT_CONFIRMED = 'PREOP_CHRONIC_PAIN_RISK_NOT_CONFIRMED',
  SPECIFIC_CARE_NEEDED = 'PREOP_CHRONIC_PAIN_SPECIFIC_CARE_NEEDED',
  ARCHIVED = 'PREOP_CHRONIC_PAIN_ARCHIVED'
}

export enum PostopChronicPainProtocolStatus {
  NOT_ELIGIBLE = 'POSTOP_CHRONIC_PAIN_NOT_ELIGIBLE',
  DN4_PENDING = 'POSTOP_CHRONIC_PAIN_DN4_PENDING',
  NO_SPECIFIC_CARE_NEEDED = 'POSTOP_CHRONIC_PAIN_NO_SPECIFIC_CARE_NEEDED',
  DN4_POSITIVE = 'POSTOP_CHRONIC_PAIN_DN4_POSITIVE',
  AUTO_DN4_POSITIVE = 'POSTOP_CHRONIC_PAIN_AUTO_DN4_POSITIVE',
  DN4_VAS_PAIN = 'POSTOP_CHRONIC_PAIN_DN4_VAS_PAIN',
  AUTO_DN4_VAS_PAIN = 'POSTOP_CHRONIC_PAIN_AUTO_DN4_VAS_PAIN',
  CONSULTATION_PENDING = 'POSTOP_CHRONIC_PAIN_CONSULTATION_PENDING',
  NEED_FOR_PROCEDURE = 'POSTOP_CHRONIC_PAIN_NEED_FOR_PROCEDURE',
  PROCEDURE_SCHEDULED = 'POSTOP_CHRONIC_PAIN_PROCEDURE_SCHEDULED',
  ARCHIVED = 'POSTOP_CHRONIC_PAIN_ARCHIVED'
}

export enum EarlyPostopProtocolStatus {
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  TO_CALL = 'TO_CALL',
  CALL_FAILED = 'CALL_FAILED',
  MONITORING = 'MONITORING',
  DONE_SUCCESS = 'DONE_SUCCESS',
  DONE_FAILED = 'DONE_FAILED'
}

export enum GenericPrescriptionProtocolStatus {
  IDLE = 'IDLE',
  PRESCRIPTION_SENT = 'PRESCRIPTION_SENT',
  ALL_PRESCRIPTIONS_VIEWED_BY_PATIENT = 'ALL_PRESCRIPTIONS_VIEWED_BY_PATIENT'
}

export enum PrescriptionStatus {
  IDLE = 'IDLE',
  SENT = 'SENT',
  VIEWED_BY_PATIENT = 'VIEWED_BY_PATIENT'
}

export enum ProtocolName {
  NICOTINE = 'nicotine-patch-protocol',
  ANEMIA = 'anemia-protocol',
  SLEEP_APNEA = 'sleep-apnea-protocol',
  NUTRITION = 'nutrition-support-protocol',
  TELEHEALTH = 'telehealth-protocol',
  PREOP_LAB_TEST = 'preop-lab-test-protocol',
  CARDIAC_STRESS_TEST = 'cardiac-stress-test-protocol',
  SURGERY_PLANNING = 'surgery-planning-protocol',
  PREOP_CHRONIC_PAIN = 'preop-chronic-pain-protocol',
  POSTOP_CHRONIC_PAIN = 'postop-chronic-pain-protocol',
  EARLY_POSTOP = 'early-postop-protocol',
  GENERIC_PRESCRIPTION = 'prescription-protocol'
}

export type CombinedProtocolStatus =
  | AnemiaProtocolStatus
  | NutritionSupportProtocolStatus
  | NicotineProtocolStatus
  | SleepApneaProtocolStatus
  | TelehealthProtocolStatus
  | PreopLabTestProtocolStatus
  | CardiacStressTestProtocolStatus
  | SurgeryPlanningProtocolStatus
  | PreopChronicPainProtocolStatus
  | PostopChronicPainProtocolStatus
  | EarlyPostopProtocolStatus
  | GenericPrescriptionProtocolStatus;

export type ToStatusTransition = {
  to: CombinedProtocolStatus;
  supportsItems: boolean;
};

export const isToStatusTransition = (obj: any): obj is ToStatusTransition =>
  !!obj &&
  typeof obj === 'object' &&
  'to' in obj &&
  'supportsItems' in obj &&
  Object.keys(obj).length === 2;

export type StatusTransitionMap = {
  [key in ProtocolName]?: {
    [k in CombinedProtocolStatus]?: ToStatusTransition[];
  };
};

export interface ProtocolStatuses {
  anemiaProtocolStatus?: AnemiaProtocolStatus;
  nicotineProtocolStatus?: NicotineProtocolStatus;
  sleepApneaProtocolStatus?: SleepApneaProtocolStatus;
  nutritionProtocolStatus?: NutritionSupportProtocolStatus;
  telehealthProtocolStatus?: TelehealthProtocolStatus;
  preopLabTestProtocolStatus?: PreopLabTestProtocolStatus;
  cardiacStressTestProtocolStatus?: CardiacStressTestProtocolStatus;
  earlyPostopProtocolStatus?: EarlyPostopProtocolStatus;
  surgeryPlanningProtocolStatus?: SurgeryPlanningProtocolStatus;
  preopChronicPainProtocolStatus?: PreopChronicPainProtocolStatus;
  postopChronicPainProtocolStatus?: PostopChronicPainProtocolStatus;
  metsStatus?: string;
  covidStatus?: string;
  anticoagulationStatus?: string;
  consentSignedStatus?: 'NOT_SENT' | 'SENT' | 'SIGNED';
  billingStatus?: 'NOT_SENT' | 'PRINTED' | 'SENT' | 'SIGNED' | 'SIGNED_ON_SITE';
}

export type ProtocolStatusMeta =
  | 'IRRELEVANT'
  | 'ACTION_REQUIRED'
  | 'ACTION_PENDING'
  | 'ACTION_DONE';

type ComputedKeys =
  | 'metsStatus'
  | 'covidStatus'
  | 'anticoagulationStatus'
  | 'consentSignedStatus';

export type ProtocolStatusesWithMeta = {
  [key in keyof Omit<ProtocolStatuses, ComputedKeys>]: {
    status: NonNullable<ProtocolStatuses[key]>;
    meta: ProtocolStatusMeta;
  };
};

export const getStatusForProtocol = (
  protocol: ProtocolName,
  dtoStatuses?: ProtocolStatuses
) => {
  if (!dtoStatuses || !protocol) {
    return undefined;
  }

  switch (protocol) {
    case ProtocolName.ANEMIA:
      return dtoStatuses.anemiaProtocolStatus;
    case ProtocolName.NICOTINE:
      return dtoStatuses.nicotineProtocolStatus;
    case ProtocolName.NUTRITION:
      return dtoStatuses.nutritionProtocolStatus;
    case ProtocolName.SLEEP_APNEA:
      return dtoStatuses.sleepApneaProtocolStatus;
    case ProtocolName.TELEHEALTH:
      return dtoStatuses.telehealthProtocolStatus;
    case ProtocolName.PREOP_LAB_TEST:
      return dtoStatuses.preopLabTestProtocolStatus;
    case ProtocolName.CARDIAC_STRESS_TEST:
      return dtoStatuses.cardiacStressTestProtocolStatus;
    case ProtocolName.SURGERY_PLANNING:
      return dtoStatuses.surgeryPlanningProtocolStatus;
    case ProtocolName.PREOP_CHRONIC_PAIN:
      return dtoStatuses.preopChronicPainProtocolStatus;
    case ProtocolName.POSTOP_CHRONIC_PAIN:
      return dtoStatuses.postopChronicPainProtocolStatus;
    case ProtocolName.EARLY_POSTOP:
      return dtoStatuses.earlyPostopProtocolStatus;
    default:
      throw new Error(`Unknown protocol: ${protocol}`);
  }
};
